/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Deep_Match_Page_TitleInputs */

const en_deep_match_page_title = /** @type {(inputs: Deep_Match_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deep Match`)
};

const de_deep_match_page_title = /** @type {(inputs: Deep_Match_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deep Match`)
};

const fr_deep_match_page_title = /** @type {(inputs: Deep_Match_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deep Match`)
};

const es_deep_match_page_title = /** @type {(inputs: Deep_Match_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deep Match`)
};

const it_deep_match_page_title = /** @type {(inputs: Deep_Match_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deep Match`)
};

const nl_deep_match_page_title = /** @type {(inputs: Deep_Match_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deep Match`)
};

const pl_deep_match_page_title = /** @type {(inputs: Deep_Match_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deep Match`)
};

const fi_deep_match_page_title = /** @type {(inputs: Deep_Match_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deep Match`)
};

const da_deep_match_page_title = /** @type {(inputs: Deep_Match_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deep Match`)
};

const sv_deep_match_page_title = /** @type {(inputs: Deep_Match_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deep Match`)
};

/**
* | output |
* | --- |
* | "Deep Match" |
*
* @param {Deep_Match_Page_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const deep_match_page_title = /** @type {((inputs?: Deep_Match_Page_TitleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deep_Match_Page_TitleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_deep_match_page_title(inputs)
	if (locale === "fr") return fr_deep_match_page_title(inputs)
	if (locale === "es") return es_deep_match_page_title(inputs)
	if (locale === "it") return it_deep_match_page_title(inputs)
	if (locale === "nl") return nl_deep_match_page_title(inputs)
	if (locale === "pl") return pl_deep_match_page_title(inputs)
	if (locale === "fi") return fi_deep_match_page_title(inputs)
	if (locale === "da") return da_deep_match_page_title(inputs)
	if (locale === "sv") return sv_deep_match_page_title(inputs)
	return en_deep_match_page_title(inputs)
});